import React, {Component} from "react"
import {Container, Divider, Grid, Header, Loader, Message, Table} from "semantic-ui-react";
import {CustomContainer} from './custom-common';
import Footer from "./footer";
import moment from "moment";
import 'moment-timezone';
import {formatMoneyAmount, resolveDisplayTier} from "../utils/common";
import {connect} from "react-redux";
import {SupportEmailLink} from "./common";
import STRATEGIC_PARTNER from "../constants/strategicPartners";
import {usePreventBackNavigation} from "../hooks";

const mapStateToProps = (state, ownProps) => {
    const {certificate, certificateHolder, contract, cost, employer, employerContribution, riderLabels, user} = state.initialData;
    const {
        initialData: {
            quoteInfo: {
                chronicRider: chronic = 0,
                mentalRider: mental = 0,
                maternityRider: maternity = 0,
            } = {}
        } = {}
    } = state;

    return {
        ...ownProps,
        authToken: state.auth.loginInfo ? state.auth.loginInfo.authToken : null,
        certificateHolder,
        user,
        contract,
        benefits: certificate.assetCoverages,
        certificate,
        cost,
        employerContribution,
        employer,
        chronic,
        mental,
        maternity,
        riderLabels,
    }
};

const withPreventBackNavigation = (WrappedComponent) => (props) => {
    usePreventBackNavigation();
    return <WrappedComponent {...props} />;
};

class SummaryReturningUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadError: null,
        };
    }

    componentDidMount() {
        const {certificate} = this.props;
        this.setState({
            loading: false,
            displayTier: !!this.props.certificate ? resolveDisplayTier(this.props.certificate.familyTier) : '',
            effectiveDate: moment(certificate.effectiveDate, "YYYY-MM-DD").toISOString(),
            loadError: null,
        });
    }

    render() {
        const {
            effectiveDate,
            displayTier,
        } = this.state;

        const {
            cost,
            employerContribution,
            contract,
            certificate,
            certificateHolder,
            benefits,
            chronic,
            maternity,
            mental,
            riderLabels,
        } = this.props;

        const hasData = (certificateHolder && benefits && contract && employerContribution !== null && cost !== null);

        if (this.state.loading || !hasData) {
            return (<Loader active/>)
        }

        if (!!this.state.loadError) {
            return <Container><CustomContainer basic style={{marginTop: '5em'}} padded><Message
                error>{this.state.loadError}</Message></CustomContainer></Container>
        }


        let displayAgeReduction = false;
        const {ageReduction, ageReductionAge, ageReductionPercentage} = contract;
        if (ageReduction) {
            if (certificate.ageAtPolicyEffectiveDate >= ageReductionAge) {
                displayAgeReduction = true;
            }
        }

        const monthlyOptions = ["Monthly", "Multiple", "Other (all costs will show monthly to employees)"]
        const isMonthly = monthlyOptions.includes(certificateHolder.payrollFrequency);
        let costPerOption = "Paycheck";
        if (isMonthly) {
            costPerOption = 'Mo';
        }

        const riders = [
            { label: riderLabels.chronic, value: chronic },
            { label: riderLabels.mental, value: mental },
            { label: riderLabels.maternity, value: maternity },
        ].filter(({ value }) => value > 0);

        return (
            <React.Fragment>
                <div className="member-main-container" style={{background: "white"}}>
                    <Grid container stackable columns={1} centered>
                        <Grid.Column width={8} className={"pageContent"}>
                            <Divider hidden/><Divider hidden/><Divider hidden/>

                            <Header as="h2">Review your selections</Header>
                            <p>Here are the coverage details you’ve selected—</p>

                            {!!displayAgeReduction && <React.Fragment>
                                <Divider hidden/>
                                <CustomContainer basic className={"bkgLinen small"}>
                                    <b>IMPORTANT</b>: Based on your age, you will receive {ageReductionPercentage}% of
                                    any benefit you select here.
                                </CustomContainer>
                                <Divider hidden/>
                            </React.Fragment>}

                            <CustomContainer style={{padding: '3em', marginBottom: '0', boxShadow: 'unset'}}>
                                <Grid columns={2}>
                                    <Grid.Column>
                                        <Grid.Row>
                                            <div className="small neutral600Text"><b>Benefit amounts</b></div>
                                            <Table basic={'very'} style={{marginTop: 0}}>
                                                <Table.Body>
                                                    <Table.Row>
                                                        <Table.Cell><b>Moderate</b></Table.Cell>
                                                        <Table.Cell>${benefits.moderate}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell><b>Severe</b></Table.Cell>
                                                        <Table.Cell>${benefits.severe}</Table.Cell>
                                                    </Table.Row>
                                                    <Table.Row>
                                                        <Table.Cell><b>Catastrophic</b></Table.Cell>
                                                        <Table.Cell>${benefits.catastrophic}</Table.Cell>
                                                    </Table.Row>
                                                </Table.Body>
                                            </Table>

                                            {employerContribution > 0 && <React.Fragment>
                                                <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                    <b>Employer contribution</b></div>
                                                <b>${formatMoneyAmount(employerContribution)} / {costPerOption}</b>
                                            </React.Fragment>
                                            }

                                            <div style={{marginTop: '1em'}}>
                                                <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                    <b>Who’s covered?</b></div>
                                                <b>{displayTier}</b>
                                            </div>
                                        </Grid.Row>
                                    </Grid.Column>

                                    <Grid.Column>
                                        <Grid.Row>
                                            {riders.length !== 0 && (
                                                <>
                                                    <div className="small neutral600Text"><b>Additional coverage</b></div>
                                                    <Table basic={'very'} style={{marginTop: 0}}>
                                                        <Table.Body>
                                                            {riders.map(({ label, value }) => (
                                                                <Table.Row key={label}>
                                                                    <Table.Cell><b>{label}</b></Table.Cell>
                                                                    <Table.Cell>${value}</Table.Cell>
                                                                </Table.Row>
                                                            ))}
                                                        </Table.Body>
                                                    </Table>
                                                </>
                                            )}

                                            <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                <b>Effective date</b>
                                            </div>
                                            <b>{moment(effectiveDate).format("MMM DD, YYYY")}</b>

                                            <div style={{marginTop: '1em'}}>
                                                <div className="small neutral600Text" style={{marginBottom: '0.4em'}}>
                                                    <b>Your cost</b>
                                                </div>
                                                <b>${formatMoneyAmount(cost)} / {costPerOption}</b>
                                            </div>
                                        </Grid.Row>
                                    </Grid.Column>
                                </Grid>
                            </CustomContainer>
                            <div className="returning-user-note">
                                <b>Note: </b><span>You've already made your {STRATEGIC_PARTNER.LABEL} elections, If you need to make a change, <SupportEmailLink
                                textOverride={'reach out to our concierge team →'}/></span>
                            </div>
                        </Grid.Column>
                    </Grid>
                </div>

                <Footer showTopFooter={false} hasToDisplayCarrierDisclaimer={true}/>
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps)(withPreventBackNavigation(SummaryReturningUser));
